import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Layout from "./components/Layout";
import ProtectedRoute from "./components/ProtectedRoute";
import ErrorBoundary from "./components/ErrorBoundary";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import Membership from "./pages/Membership";
import Governance from "./pages/Governance";
import Admin from "./pages/Admin";
import Accounting from "./pages/Accounting";
import Legal from "./pages/Legal";
import Media from "./pages/Media";
import Committees from "./pages/Committees";
import Documents from "./pages/Documents";
import DataManagement from "./pages/DataManagement";
import { DataProvider } from "./context/DataContext";
import { AuthProvider } from "./context/AuthContext";
import { FileProvider } from "./context/FileContext";
import { DataManagementProvider } from "./context/DataManagementContext";
import { ToastProvider } from "./context/ToastContext";

function App() {
  return (
    <ErrorBoundary>
      <AuthProvider>
        <DataProvider>
          <FileProvider>
            <DataManagementProvider>
              <ToastProvider>
                <Router>
                  <Routes>
                    <Route path="/login" element={<Login />} />
                    <Route
                      path="/*"
                      element={
                        <ProtectedRoute>
                          <Layout>
                            <Routes>
                              <Route path="/" element={<Dashboard />} />
                              <Route
                                path="/membership"
                                element={
                                  <ProtectedRoute
                                    requiredPermissions={["membership"]}
                                  >
                                    <Membership />
                                  </ProtectedRoute>
                                }
                              />
                              <Route
                                path="/governance"
                                element={
                                  <ProtectedRoute
                                    requiredPermissions={["governance"]}
                                  >
                                    <Governance />
                                  </ProtectedRoute>
                                }
                              />
                              <Route
                                path="/admin"
                                element={
                                  <ProtectedRoute
                                    requiredPermissions={["admin"]}
                                  >
                                    <Admin />
                                  </ProtectedRoute>
                                }
                              />
                              <Route
                                path="/accounting"
                                element={
                                  <ProtectedRoute
                                    requiredPermissions={["finance"]}
                                  >
                                    <Accounting />
                                  </ProtectedRoute>
                                }
                              />
                              <Route
                                path="/legal"
                                element={
                                  <ProtectedRoute
                                    requiredPermissions={["legal"]}
                                  >
                                    <Legal />
                                  </ProtectedRoute>
                                }
                              />
                              <Route
                                path="/media"
                                element={
                                  <ProtectedRoute
                                    requiredPermissions={["media"]}
                                  >
                                    <Media />
                                  </ProtectedRoute>
                                }
                              />
                              <Route
                                path="/committees"
                                element={
                                  <ProtectedRoute
                                    requiredPermissions={["membership"]}
                                  >
                                    <Committees />
                                  </ProtectedRoute>
                                }
                              />
                              <Route
                                path="/documents"
                                element={
                                  <ProtectedRoute
                                    requiredPermissions={["admin"]}
                                  >
                                    <Documents />
                                  </ProtectedRoute>
                                }
                              />
                              <Route
                                path="/data-management"
                                element={
                                  <ProtectedRoute
                                    requiredPermissions={["admin"]}
                                  >
                                    <DataManagement />
                                  </ProtectedRoute>
                                }
                              />
                            </Routes>
                          </Layout>
                        </ProtectedRoute>
                      }
                    />
                  </Routes>
                </Router>
              </ToastProvider>
            </DataManagementProvider>
          </FileProvider>
        </DataProvider>
      </AuthProvider>
    </ErrorBoundary>
  );
}

export default App;
